import axios, { AxiosResponse } from 'axios';
import { store } from "../redux/store";
import * as crypto from 'crypto';

const responseBody = (response: AxiosResponse) => response.data;

const createInstance = (authorize = true, multipart = false,
    base_url = `${Api.base_url1}`) => {
    let token = store.getState().user.jwt;

    const headers: Record<string, string> = {
        Accept: 'application/json',
    };
    if (authorize && token) {
        headers.Authorization = `Bearer ${token}`;
    }
    if (multipart) {
        headers['content-type'] = 'multipart/form-data';
    }
    return axios.create({
        baseURL: base_url,
        timeout: 0,
        headers
    });
}
const requests = {
    get: (url: string, authorize = true) => {
        return createInstance(authorize).get(url).then(responseBody)
    },
    post: (url: string, body: {}, authorize = true, multipart = false) => {
        return createInstance(authorize, multipart).post(url, body).then(responseBody)
    },
    put: (url: string, body: {}, authorize = true) => {
        return createInstance(authorize).put(url, body).then(responseBody)
    },
    delete: (url: string, authorize = true) => {
        return createInstance(authorize).delete(url).then(responseBody)
    },
};

export const Api = {
    base_url: '',
    // base_url1: 'https://backend-hp.certificates.itmatic.io',
    // base_url1: 'http://localhost:1337',
    base_url1: 'https://backend.certificates.codebrigade.in', 

    updateProfile: (params: Map<string, any>) => {
        return requests.post("/users/me", params);
    },
    getProfile: () => {
        return requests.get("/users/me");
    },

    login: (params: Map<string, string>) => {
        return requests.post('/auth/local', params, false);
    },

    changePassword(params: Map<string, any>) {
        return requests.post('/auth/reset-password', params, false);
    },

    uploadFile(data: FormData) {
        return requests.post(`/upload`, data, true, true);
    },

    deleteFile(id: string) {
        return requests.delete(`/upload/files/${id}`);
    },

    register(params: Map<string, any>) {
        return requests.post('/auth/local/register', params, false);
    },

    forgetPassword(params: Map<string, any>) {
        return requests.post('/auth/forgot-password', params, false);
    },

    newPassword(params: Map<string, any>) {
        return requests.post('/password', params, false);
    },

    getTemplates() {
        return requests.get("/getTemplateData");
    },

    getReport(id: string) {
        return requests.get(`/registrations/${id}`);
    },
    call(path: string, method = "GET", data: Map<string, any>) {
        switch (method) {
            case 'GET':
                return requests.get(path);
            case 'POST':
                return requests.post(path, data);
            case 'PUT':
                return requests.put(path, data);
            case 'DELETE':
                return requests.delete(path);
        }
    },

    updateTemplate(params: Map<string, string>) {
        // @ts-ignore
        if (params.id) {
            // @ts-ignore
            return requests.put(`/templates/${params.id}`, params);
        }
        return requests.post(`/templates`, params);
    },
    updateCertificate(params: Map<string, string>) {
        // @ts-ignore
        if (params.id) {
            // @ts-ignore
            return requests.put(`/certificates/${params.id}`, params);
        }
        return requests.post(`/certificates`, params);
    },
    getTemplate(id: string) {
        return requests.get(`/templates/${id}`);
    },
    getCertificate(id: string) {
        return requests.get(`/certificates/${id}`);
    },
    getCertificates() {
        return requests.get(`/certificates`);
    },
    generateHMAC(message: string) {
        const key = "65478911111111111111111111111111";
        const iv = "1222221111111111";
        const cipher = crypto.createCipheriv('aes-256-cbc', key, iv);
        const encrypted = Buffer.concat([
            cipher.update(message, 'utf8'),
            cipher.final(),
        ]);
        return encrypted.toString('base64');
    },

    decryptText(encrypted: string) {
        const key = Buffer.from("65478911111111111111111111111111", 'utf-8'); // Key as Buffer
        const iv = Buffer.from("1222221111111111", 'utf-8'); // IV as Buffer

        // Convert Base64 string back to Buffer
        const encryptedBuffer = Buffer.from(encrypted, 'base64'); // Correct decoding
        const decipher = crypto.createDecipheriv('aes-256-cbc', key, iv);

        const decrypted = Buffer.concat([
            decipher.update(encryptedBuffer),
            decipher.final(),
        ]);
        return decrypted.toString('utf8'); // Return as string
    }
};
